<div class="frame-container">
  <div class="component-title">
    <label class="title-label">{{ componentTitle }}</label>
  </div>
  <ng-content></ng-content>
</div>
